import {  Component, EventEmitter, HostListener, OnInit, ViewChild } from '@angular/core';
import { KontableComponent } from 'app/modules/UIKit/components/kontable/kontable.component';
import { Campaign3Service } from '../../campaign-3/services/campaign3.service';
import { Campaign3BreadcrumbComponent } from '../../campaign-3/components/campaign-3-breadcrumb/campaign-3-breadcrumb.component';
import { BreadCrumbModel } from '../../campaign-3/models/campaign-3-breadcrumb.model';
import { ActivatedRoute, Router } from '@angular/router';

import { Campaign3KontableComponent } from '../../campaign-3/components/campaign-3-kontable/campaign-3-kontable.component';
import { CalendarTranslateService } from 'app/modules/UIKit/services/calendarTranslate.service';
import { ActionStateService } from '../../campaign-3/services/actionstate.service';
import { MessageService } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { BasketService } from '../basket.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Basket, ProductItemComplete } from '../baskets.model';
import { take } from 'rxjs/operators';





@Component({
    selector: 'app-basket-list',
    templateUrl: './basket-list.component.html',
    styleUrls: ['./basket-list.component.css']
})
export class BasketListComponent implements OnInit {

    @ViewChild('breadcrumbComponent') breadcrumb: Campaign3BreadcrumbComponent;
    @ViewChild('basketsListKontableComponent') kontableComponent: Campaign3KontableComponent;

    breadcrumbs: Array<BreadCrumbModel> = [];
    paginationType = KontableComponent.ServerPagination;
    dateFilter = KontableComponent.DateFilter;
    numberFilter = KontableComponent.NumberFilter;
    textFilter = KontableComponent.TextFilter;
    selectFilter = KontableComponent.SelectFilter;
    noFilter = KontableComponent.NoFilter;
    pageSubject = "baskets";
    showPopupEdit = false;
    showPopupCreate = false;
    readyTable = false;
    elaboratingIdBasket: number;
    currentOpenedRow: number;
    displayDeleteDialog = false;
    duplicateBasketForm: FormGroup;
    idBasketToDuplicate: number



    displayBasketConfirmDialog = false;
    displayRecoverBasketConfirmDialog = false;

    basketSelected: any = null;
    basketConfirmAction: 'EMPTY' | 'DELETE' | 'RECOVER' | null = null;
    basketConfirmMessage = ''

    //NEW VARIABLES
    showBreadCrumb: boolean = false;
    showMenu: boolean = false;
    show = {
        modalPaniereAdd: false,
        modalPaniereRemove: false,
        modalDuplicateBasket: false
    }

    paniereList;
    productsList: Array<ProductItemComplete> = [];
    filteredProductList: Array<ProductItemComplete> = [];
    productsListAlreadySelected: Array<ProductItemComplete> = [];
    translationsMap: { [key: string]: string } = {};
 actionStatusList: Array<{ label: string; value: string }> = [];
    basketIdFromRoute

    constructor(
        public campaign3Service: Campaign3Service,
        public basketService: BasketService,
        public router: Router,
        public srvCalendar: CalendarTranslateService,
        public actionStateService: ActionStateService,
        private srvNotify: MessageService,
        private translateService: TranslateService,
        private fb: FormBuilder,
        private route: ActivatedRoute


    ) {

        this.duplicateBasketForm = this.fb.group({
            name: ['', Validators.required],
            code: ['', [Validators.required]],
            description: ['']
        });
    }
   
ngOnInit(): void {

  this.route.queryParams
    .pipe(take(1)) // eviti subscribe multipli
    .subscribe(params => {

      const id = params['basketId'];
      if (id) {
        this.basketIdFromRoute = Number(id);
      }

      // Creo la tabella DOPO aver letto i parametri
 

      // Inizializzo il resto
      this.initBreadCrumbs();
      this.loadFilterList();
    });

}

applyInitialIdFilter(id: number): void {

  const table = this.kontableComponent;
  if (!table) return;

  // Imposto filtro direttamente
    table.filter.search = [{ key: 'id', value: String(id) }];
            table.updateTableFilter(null, null, null, 1, 1000, true);
// Pulisco la ricerca
            table.filter.search = [];


  // Rimuovo parametro dall’URL
  this.router.navigate([], {
    relativeTo: this.route,
    queryParams: { basketId: null },
    queryParamsHandling: 'merge',
    replaceUrl: true
  });

}

    private loadFilterList(): void {
        this.translateService.get([
            'baskets.active',
            'baskets.deleted',
            'baskets.creating',
            'baskets.duplication_error',
        ]).subscribe(translations => {

            this.translationsMap = translations;
            this.actionStatusList = [
                { label: '', value: '' },
                { label: translations['baskets.active'], value: '0' },
                { label: translations['baskets.deleted'], value: '1' },
                { label: translations['baskets.creating'], value: '2' },
                { label: translations['baskets.duplication_error'], value: '3' }

            ];
                  this.readyTable = true;
            if (this.basketIdFromRoute) {
                // Aspetto che la view sia stabile
                setTimeout(() => {
                this.applyInitialIdFilter(this.basketIdFromRoute);
                });
            }
        });
    }
    translateState(value: string): string {
        switch (value) {
            case '0':
                return this.translationsMap['baskets.active'] || '';
            case '1':
                return this.translationsMap['baskets.deleted'] || '';
            case '2':
                return this.translationsMap['baskets.creating'] || '';
            case '3':
                return this.translationsMap['baskets.duplication_error'] || '';
            default:
                return '';
        }
    }



    breadcrumbClicked(breadcrumb: BreadCrumbModel) {
        if (breadcrumb.routerLink) {
            this.router.navigate([breadcrumb.routerLink]);
        } else {
            console.log("Nessuna route implementata");
        }
    }

    private initBreadCrumbs() {

        let breadCrumbDistribution;

        this.translateService.get([
            'breadCrumb.baskets_list',
        ]).subscribe(translations => {
            breadCrumbDistribution = translations['breadCrumb.baskets_list'];
            this.breadcrumbs = [
                { code: 'bc1', description: breadCrumbDistribution, routerLink: '/baskets-list' },

            ];
            this.showBreadCrumb = true;
        });
    }

    onOpenEdit(row: Basket): void {
        this.router.navigate(['/basket-creation'], {
            queryParams: { idBasket: row.id }
        });
    }



    onOpenCreation() {
        /*  this.distributionService.resetData(); */
        this.router.navigate(['/basket-creation']);
    }



    onActionTable() {
        this.router.navigate(["/action-list-3"]);
    }

    onClosePopupEdit() {
        this.showPopupEdit = false;
    }

    onClosePopupCreation() {
        this.showPopupCreate = false;
    }



    refreshAfterEdit() {
        this.kontableComponent.refresh();
    }
    /**
     * Logica centralizzata per abilitazione/disabilitazione bottoni per riga.
     * Restituisce true se il bottone deve essere DISABILITATO.
     *
     * Azioni riconosciute:
     *   'edit', 'viewArticles', 'duplicate', 'addProduct', 'removeProducts',
     *   'viewActions', 'viewPromos', 'importCsv', 'emptyBasket', 'delete'
     */
    isButtonDisabled(row: any, action: string): boolean {
        const enabled = String(row.flg_enabled);
        const state = String(row.flg_state);

        // recover abilitato SOLO quando flg_state=1, disabilitato in tutti gli altri casi
        if (action === 'recover') {
            return !(enabled === '0' && state === '1');
        }

        // flg_enabled=1, flg_state=1 → tutti i bottoni disabilitati
        if (enabled === '1' && state === '1') return true;

        // flg_enabled=1, flg_state=0 → solo operazioni di visualizzazione
        if (enabled === '1' && state === '0') {
            const allowedActions = ['viewArticles', 'viewActions', 'viewPromos'];
            return allowedActions.indexOf(action) === -1;
        }

        // flg_enabled=0, flg_state=0 → tutte le operazioni abilitate
        if (enabled === '0' && state === '0') return false;

        // flg_enabled=0, flg_state=1 → solo recover (già gestito sopra)
        if (enabled === '0' && state === '1') return true;

        // flg_enabled=0, flg_state=2 → solo import da CSV
        if (enabled === '0' && state === '2') {
            return action !== 'importCsv';
        }

        // flg_enabled=0, flg_state=3 → solo elimina
        if (enabled === '0' && state === '3') {
            return action !== 'delete';
        }

        // default: disabilitato
        return true;
    }

    /** Il menu a tendina è disabilitato solo quando tutti i bottoni interni lo sono (flg_state=1) */
    isMenuDisabled(row: any): boolean {
        return row.flg_state === '1';
    }



    toggleMenu(row: any) {
        let id = row.id;
        if (this.showMenu && this.currentOpenedRow !== id) {
            this.showMenu = false;
        }
        this.currentOpenedRow = id;
        this.showMenu = !this.showMenu;
    }

    @HostListener('document:click', ['$event'])
    onClick(event: any) {
        if (!event.target.closest('.dropdown-menu') && !event.target.closest('.d-flex')) {
            this.showMenu = false;
        }
    }

    deleteDistributionList(row: any) {
        // this.distributionListToDelete = row;
        console.log("Procedere con i controlli, popup e infine definitiva eliminazione");
        this.displayDeleteDialog = true;
    }

    closePopupDelete() {
        this.displayDeleteDialog = false;
    }



    onViewArticlesList(row: any) {
        this.router.navigate(['/basket-articles'], {
            queryParams: { idRow: row.id }
        });
    }


    productsNotInSelectedBasket: any[] = []
    onAddProductToBasket(row: any): void {
        let canProceed = true;
        this.elaboratingIdBasket = null;
        if (!row || row.id === null || row.id === undefined) {
            console.warn('onAddProductToBasket: row non valido', row);
            canProceed = false;
        }

        if (canProceed) {
            this.elaboratingIdBasket = row.id;
            this.basketService.getProductItemNotInBasket(row.id).subscribe(
                res => {
                    this.productsNotInSelectedBasket = res.data;
                }
            );
            this.show.modalPaniereAdd = true;
        }
    }

    onDuplicateBasket(row: Basket) {

        this.idBasketToDuplicate = row.id;
        this.show.modalDuplicateBasket = true;
    }

    closeDuplicateBasketModal(): void {
        this.show.modalDuplicateBasket = false;

        if (this.duplicateBasketForm) {
            this.duplicateBasketForm.reset();
            this.duplicateBasketForm.markAsPristine();
            this.duplicateBasketForm.markAsUntouched();
        }
    }

    onSubmitDuplicateBasket(): void {
        if (!this.duplicateBasketForm) {
            return;
        }

        if (this.duplicateBasketForm.invalid) {
            this.duplicateBasketForm.markAsTouched(); // evidenzia tutti i campi invalidi
        } else {
            const formValue = this.duplicateBasketForm.value;
            console.log('[onSubmitDuplicateBasket] dati inseriti:', formValue);

            this.basketService.duplicateBasket({
                id: this.idBasketToDuplicate,
                code: formValue.code,
                name: formValue.name,
                description: formValue.description
            }).subscribe(
                response => {
                    console.log('[duplicateBasket] response:', response);

                    // Messaggio di successo
                    this.srvNotify.add({
                        severity: 'success',
                        summary: this.translateService.instant('common.success'),
                        detail: this.translateService.instant('baskets.duplicate_ok')
                    });
                    this.closeDuplicateBasketModal();
                },
                error => {
                    console.error('[duplicateBasket] errore:', error);

                    // Messaggio di errore
                    this.srvNotify.add({
                        severity: 'error',
                        summary: this.translateService.instant('common.error'),
                        detail: this.translateService.instant('baskets.duplicate_ko')
                    });

                }
            );
        }
    }



    // ==============================
    // SALVATAGGIO / ANNULLA (ADD)
    // ==============================
    onProductsToAddSelected(data: ProductItemComplete[]): void {
        let canProceed = true;
        if (!data || this.elaboratingIdBasket === null || this.elaboratingIdBasket === undefined) {
            console.warn('onProductsToAddSelected: dati non validi', data);
            canProceed = false;
        }

        if (canProceed) {
            console.log('onProductsToAddSelected: invio dati al servizio', data);
            console.log(this.elaboratingIdBasket);

            this.basketService.addProductToBasket(this.elaboratingIdBasket, data).subscribe(
                response => {
                    console.log('[addProductToBasket] response:', response);

                    // Messaggio di successo
                    this.srvNotify.add({
                        severity: 'success',
                        summary: this.translateService.instant('common.success'),
                        detail: this.translateService.instant('baskets.products_added_success')
                    });
                    this.kontableComponent.refresh();

                },
                error => {
                    console.error('[addProductToBasket] errore:', error);

                    // Messaggio di errore
                    this.srvNotify.add({
                        severity: 'error',
                        summary: this.translateService.instant('common.error'),
                        detail: this.translateService.instant('baskets.products_added_error')
                    });
                }
            );
        }

        this.resetAddProductModal();
    }

    onCloseProductToAdd(): void {
        this.resetAddProductModal();
    }

    private resetAddProductModal(): void {
        this.elaboratingIdBasket = null;
        this.show.modalPaniereAdd = false;
    }

    // ==============================
    // SALVATAGGIO / ANNULLA (REMOVE)
    // ==============================


    idBasketOfProductsToRemove: number
    private extractProductsByBasketAndOpenModal(row: any): void {
        this.productsListAlreadySelected = [];

        let canProceed = true;
        let id = null;

        if (!row || row.id === null || row.id === undefined) {
            console.error('extractProductsByBasketAndOpenModal: row non valido', row);
            canProceed = false;
        }

        if (canProceed) {
            id = row.id;
            console.log('extractProductsByBasketAndOpenModal: id', id);
            this.idBasketOfProductsToRemove = id;
        }

        if (canProceed) {
            this.basketService.getBasketProduct(id).subscribe(
                res => {
                    let canOpenModal = true;

                    if (!res || !Array.isArray(res)) {
                        console.error('Risposta servizio non valida', res);
                        canOpenModal = false;
                    }

                    if (canOpenModal && res.length === 0) {
                        console.warn('Il paniere non contiene prodotti');
                        this.srvNotify.add({
                            severity: 'warn',
                            summary: this.translateService.instant('common.warning'),
                            detail: this.translateService.instant('baskets.empty_basket_status')
                        });

                        canOpenModal = false;
                    }

                    if (canOpenModal) {
                        for (let i = 0; i < res.length; i++) {
                            if (res[i]) {
                                this.productsListAlreadySelected.push(res[i]);
                            }
                        }

                        this.show.modalPaniereRemove = true;
                    }
                },
                error => {
                    console.error('Errore nel recupero dei prodotti', error);
                }
            );
        }
    }

    //TODO: da capire con antonio se recuperare paraemtro corretto nella compete lui vuole basketdetailid
    onProductsToRemoveSelected(data: ProductItemComplete[]): void {
        let canProceed = true;
        if (!data || this.idBasketOfProductsToRemove === null || this.idBasketOfProductsToRemove === undefined) {
            console.warn('onProductsToRemoveSelected: dati non validi', data);
            canProceed = false;
        }

        if (canProceed) {
            console.log('onProductsToRemoveSelected: invio dati al servizio', data);
            if (this.idBasketOfProductsToRemove) {
                this.basketService.removeProducts(this.idBasketOfProductsToRemove, data).subscribe(res => {
                    console.log(res);
                    this.srvNotify.add({
                        severity: 'success',
                        summary: this.translateService.instant('common.error'),
                        detail: this.translateService.instant('baskets.products_removed_ok')
                    });
                    this.kontableComponent.refresh()
                });
            }


        }

        this.show.modalPaniereRemove = false;
    }

    onCloseProductToRemove(): void {
        this.elaboratingIdBasket = null;
        this.show.modalPaniereRemove = false;
    }



    /*  onImportFromCsv(row: any): void {
         if (!this.isBasketEditable(row)) {
             return;
         }
         this.showModalImportCsv=true;
         
 
         // tipicamente qui apri una modale upload
         console.log('Import CSV per paniere', row.id);
         
     } */
    /*     showModalImportCsv = false;
    basketSelected: any = null; */


    onEmptyBasket(row: any): void {
        if (!this.isBasketEditable(row)) {
            return;
        }

        this.basketSelected = row;
        this.basketConfirmAction = 'EMPTY';

        this.basketConfirmMessage = this.hasActivePromos(row)
            ? 'baskets.confirm_empty_with_promo'
            : 'baskets.confirm_empty';

        this.displayBasketConfirmDialog = true;
    }
    onDeleteBasket(row: any): void {
        if (!this.isBasketEditable(row)) {
            return;
        }

        this.basketSelected = row;
        this.basketConfirmAction = 'DELETE';

        this.basketConfirmMessage = this.hasActivePromos(row)
            ? 'baskets.confirm_delete_with_promo'
            : 'baskets.confirm_delete';

        this.displayBasketConfirmDialog = true;
    }

    onRecoverBasket(row: any): void {
        if (!this.isBasketEditable(row)) {
            return;
        }

        this.basketSelected = row;
        this.basketConfirmAction = 'RECOVER';

        this.basketConfirmMessage = this.hasActivePromos(row)
            ? 'baskets.confirm_recover_with_promo'
            : 'baskets.confirm_recover';

        this.displayRecoverBasketConfirmDialog = true;
    }


    onConfirmBasketAction(): void {
        if (!this.basketSelected || !this.basketConfirmAction) {
            this.closeBasketConfirmDialog();
            return;
        }

        const basketId = this.basketSelected.id;

        const request$ =
            this.basketConfirmAction === 'EMPTY'
                ? this.basketService.emptyBasket(basketId)
                : this.basketService.deleteBasket(basketId);

        request$.subscribe({
            next: () => {
                this.srvNotify.add({
                    severity: 'success',
                    summary: this.translateService.instant('common.success'),
                    detail: this.translateService.instant(
                        this.basketConfirmAction === 'EMPTY'
                            ? 'baskets.empty_ok'
                            : 'baskets.delete_ok'
                    )
                });


                this.closeBasketConfirmDialog();
                this.kontableComponent.refresh();
            },
            error: (err) => {
                console.error(err);

                this.srvNotify.add({
                    severity: 'error',
                    summary: this.translateService.instant('common.error'),
                    detail: this.translateService.instant('baskets.operation_ko')
                });


                this.closeBasketConfirmDialog();
            }
        });
    }

    onConfirmRecoverBasketAction(): void {
        if (!this.basketSelected || !this.basketConfirmAction) {
            this.closeRecoverBasketConfirmDialog();
            return;
        }

        const basketId = this.basketSelected.id;

        const request$ = this.basketService.recoverBasket(basketId, this.basketSelected);

        request$.subscribe({
            next: () => {
                this.srvNotify.add({
                    severity: 'success',
                    summary: this.translateService.instant('common.success'),
                    detail: this.translateService.instant(
                        this.basketConfirmAction === 'RECOVER'
                            ? 'baskets.empty_ok'
                            : 'baskets.recover_ok'
                    )
                });


                this.closeRecoverBasketConfirmDialog();
                this.kontableComponent.refresh();
            },
            error: (err) => {
                console.error(err);

                this.srvNotify.add({
                    severity: 'error',
                    summary: this.translateService.instant('common.error'),
                    detail: this.translateService.instant('baskets.operation_ko')
                });


                this.closeRecoverBasketConfirmDialog();
            }
        });
    }

    closeBasketConfirmDialog(): void {
        this.displayBasketConfirmDialog = false;
        this.basketSelected = null;
        this.basketConfirmAction = null;
        this.basketConfirmMessage = '';
    }

    closeRecoverBasketConfirmDialog(): void {
        this.displayRecoverBasketConfirmDialog = false;
        this.basketSelected = null;
        this.basketConfirmAction = null;
        this.basketConfirmMessage = '';
    }




    /**
     * Verifica se il paniere è modificabile
     * (per ora sempre true)
     */
    isBasketEditable(row: any): boolean {
        return true;
    }

    /**
     * Verifica se il paniere ha promo attive
     * (per ora sempre false → niente warning extra)
     */
    hasActivePromos(row: any): boolean {
        return false;
    }

    /**
     * Verifica se una feature è abilitata
     * (parametri di installazione)
     * per ora sempre true
     */
    isFeatureEnabled(featureCode: string): boolean {
        return true;
    }



    onViewActivePromos(row: Basket): void {
        let canNavigate = true;

        if (!row) {
            console.error('[onViewPromoList] row non valorizzata', row);
            canNavigate = false;
        } else if (row.id === null || row.id === undefined) {
            console.error('[onViewPromoList] basket_id mancante', row);
            canNavigate = false;
        }
        if (canNavigate) {
            this.router.navigate(
                ['/basket-promo-list'],
                {
                    queryParams: {
                        basketId: row.id,
                        basketCode: row.code
                    }
                }
            );
        }
    }

    onViewActiveActions(row: Basket): void {
        let canNavigate = true;

        if (!row) {
            console.error('[onViewActionList] row non valorizzata', row);
            canNavigate = false;
        } else if (row.id === null || row.id === undefined) {
            console.error('[onViewActionList] basket_id mancante', row);
            canNavigate = false;
        }

        if (canNavigate) {
            this.router.navigate(
                ['/basket-action-list'],
                { queryParams: { basketId: row.id } }
            );
        }
    }






    //CSV SECTION
    onImportFromCsv(row: Basket) {
        let canNavigate = true;

        if (!row) {
            console.error('[onViewPromoList] row non valorizzata', row);
            canNavigate = false;
        } else if (row.id === null || row.id === undefined) {
            console.error('[onViewPromoList] basket_id mancante', row);
            canNavigate = false;
        }

        if (canNavigate) {
            this.router.navigate(
                ['/basket-import-csv'],
                { queryParams: { basketId: row.id } }
            );
        }
    }









}




// WEBPACK FOOTER //
// ./src/app/views/baskets/baskets-list/basket-list.component.ts